module.exports = __webpack_public_path__ + "img/blue_wl.b4e8eeb1.png";